import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// PrimeNG Components
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';

// Modules
import { UserRoutingModule } from './user-routing.module';
import { ComponentsModule } from '../components/components.module';

// Application Components
import { SolicitudesComponent } from './solicitudes/solicitudes.component';
import { TramitesComponent } from './tramites/tramites.component';
import { PagarMandamientoComponent } from './pagar_mandamiento/pagar_mandamiento.component';

@NgModule({
  declarations: [SolicitudesComponent, TramitesComponent, PagarMandamientoComponent],
  imports: [
    CommonModule,
    UserRoutingModule,
    ComponentsModule,
    CardModule,
    TableModule,
    DialogModule,
    FileUploadModule,
    ConfirmDialogModule,
    TooltipModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    FormsModule
  ]
})

export class UserModule { }
